export enum AuthStatus {
    None,
    Successful = 1,
    Failed,
    ServerError
}